import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const LiveClassEdit = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [teacherName, setTeacherName] = useState([]);
  const [price, setPrice] = useState("");
  const [thumbnail, setThumbnail] = useState(null); // Can handle file or URL
  const { editId } = useParams();

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/live-classes/${editId}`)
      .then((response) => {
        const data = response.data?.data;
        if (data) {
          setTitle(data.title || "");
          setDescription(data.description || "");
          setTeacherName(data.teacherName || []);
          setPrice(data.price || "");
          setThumbnail(data.thumbnail || null); // Assuming it is a URL path
        }
      })
      .catch((error) => console.log(error));
  }, [editId, API_BASE_URL]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("price", price);

    // Append file if thumbnail has been updated
    if (typeof thumbnail === "object") {
      formData.append("thumbnail", thumbnail);
    } else {
      formData.append("thumbnail", thumbnail); // For URL/path value
    }

    teacherName.forEach((teacher, index) => {
      formData.append(`teacherName[${index}]`, teacher);
    });

    try {
      await axios.put(
        `${API_BASE_URL}/admin/live-classes/${editId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      alert("Live class updated successfully!");
      navigate("/live-class-list");
    } catch (error) {
      console.error("Failed to update live class:", error);
    }
  };

  const handleAddTeacherName = () => {
    setTeacherName([...teacherName, ""]);
  };

  const handleTeacherNameChange = (index, value) => {
    const updatedTeacherName = [...teacherName];
    updatedTeacherName[index] = value;
    setTeacherName(updatedTeacherName);
  };

  return (
    <div id="add-subject-inner-wrapper">
      <div className="superheader">
        <div className="subjectHeaderdiv">
          <h5>Live Classes</h5>
          <div className="subjectdiv2">
            <button
              className="handleNewSubject"
              onClick={() => navigate("/live-class-add")}
            >
              + Add New Live Class
            </button>
            <button
              className="allSubjects"
              onClick={() => navigate("/live-class-list")}
            >
              All Live Class
            </button>
          </div>
        </div>

        <div className="form-sub-container mt-4" id="form">
          <h4 className="subject-detail">Update Live Class Details</h4>
          <form className="subject-detail-form" onSubmit={handleSubmit}>
            <div className="input-group">
              <label className="label">Title</label>
              <input
                type="text"
                placeholder="Enter Title"
                required
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>

            <div className="input-group">
              <label className="label">Description</label>
              <input
                type="text"
                placeholder="Enter Description"
                required
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>

            <div className="input-group">
              <label className="label">Teacher names</label>
              {teacherName.map((teacher, index) => (
                <input
                  key={index}
                  type="text"
                  placeholder="Enter Teacher Name"
                  required
                  className="mt-2"
                  value={teacher}
                  onChange={(e) =>
                    handleTeacherNameChange(index, e.target.value)
                  }
                />
              ))}
              <button
                type="button"
                className="btn-add-teacher"
                onClick={handleAddTeacherName}
              >
                + Add Teacher
              </button>
            </div>

            <div className="input-group">
              <label className="label">Price</label>
              <input
                type="text"
                placeholder="Enter Price"
                required
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              />
            </div>

            <div className="input-group">
              <label className="label">Thumbnail</label>
              <input
                type="file"
                onChange={(e) => setThumbnail(e.target.files[0])}
              />
              {typeof thumbnail === "string" && (
                <img
                  src={`${API_BASE_URL}/uploads/${thumbnail}`}
                  alt="Current Thumbnail"
                  style={{ width: "100px", marginTop: "10px" }}
                />
              )}
            </div>

            <div className="school-subj-form-btns">
              <button className="btn-search" type="submit">
                Update
              </button>
              <button
                className="btn-cancel"
                type="button"
                onClick={() => navigate("/live-class-list")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LiveClassEdit;
